import React, { useEffect, useState } from "react";
import axios from "../../axios";
import urls from "../../Utils/urls";
import { Button, Table } from "react-bootstrap";
import { ChevronDown, ChevronUp, Search } from "react-bootstrap-icons";
import ReportsAndDocumentsIcon from "mdi-react/FileDocumentOutlineIcon";
import DownloadIcon from "mdi-react/DownloadIcon";
import { useSelector } from "react-redux";
import fetchAttachmentData, {
  updateLinkURLNew,
  removeSpanTag,
} from "../../Utils";
import moment from "moment";
import { useAbortController } from "../../hooks/useAbortController";
import { PaginatedTable } from "./AttachmentsTab";
import { SpinnerBlock } from "../../Utils/CustomComponent";

const BorrowerViewStatement = ({ loanID }) => {
  const accountId = useSelector((state) => state.account.lenderId);
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const [attachments, setAttachments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const { signal } = useAbortController();

  useEffect(() => {
    const fetchAttachments = async () => {
      let resp;
      setLoading(true);
      try {
        // const url = urls.broker.getAttachments(loanID ? loanID : accountId);
        const url = urls.broker.getAttachments(loanID);

        const res = await axios.get(url, { signal });

        resp = res.data[0]?.map((data) => {
          const htmlObject = document.createElement("div");
          htmlObject.innerHTML = data.attachment;
          const titleValue = removeSpanTag(
            htmlObject?.getElementsByTagName("a")?.[0]?.innerHTML
          );
          const hrefValue = updateLinkURLNew(
            htmlObject?.getElementsByTagName("a")?.[0]?.getAttribute("href")
          );
          data.Attachment = { href: hrefValue, title: titleValue };
          return data;
        });

        const filterAttachmentsByTitle = (title) =>
          resp.filter((item) =>
            item["Attachment"].title.toLowerCase().includes(title.toLowerCase())
          );

        const attachmentCategories = [
          { title: "Statement Of Account", filter: "Statement" },
        ];

        const otherFilter = attachmentCategories.map((cat) => cat.filter);

        const other = resp.filter(
          (item) =>
            !otherFilter.some((filter) =>
              item["Attachment"].title
                .toLowerCase()
                .includes(filter.toLowerCase())
            )
        );

        setAttachments(
          attachmentCategories.map(({ title, filter }) => ({
            title,
            list: filterAttachmentsByTitle(filter),
            open: true,
          }))
        );
        setLoading(false);
      } catch (error) {
        console.error("Error fetching attachments:", error);
        setLoading(false);
      }
    };

    if (loanID) {
      fetchAttachments();
    }
  }, [loanID]);

  const toggleCategoryOpen = (title) => {
    setAttachments((currentCategories) =>
      currentCategories.map((category) =>
        category.title === title
          ? { ...category, open: !category.open }
          : category
      )
    );
  };

  const handleClick = async (data) => {
    const attachmentsUrl = await fetchAttachmentData(data);
    window.open(attachmentsUrl);
  };

  return (
    <div
      style={{ padding: "20px" }}
      className="bg-white rounded attachments-table"
    >
      <section>
        <div>
          <div className="d-lg-flex justify-content-lg-between">
            <div className="d-flex flex-column">
              <p className="p-0 m-0 fs-4 fw-bold">View Statement</p>
            </div>
            <div className="d-flex flex-sm-column flex-lg-row">
              <div className="me-lg-3 me-sm-0">
                <div className="input-group mb-3">
                  <span
                    className="input-group-text input-icon"
                    id="basic-addon1"
                  >
                    <Search />
                  </span>
                  <input
                    type="text"
                    className="form-control search-input"
                    placeholder="Search"
                    aria-label="Search"
                    aria-describedby="basic-addon1"
                    onChange={(e) => setSearchQuery(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </div>
          {!loading ? (
            attachments.map((item, index) => (
              <div key={index} className="d-flex flex-column mb-5">
                <div
                  className="p-4 mb-4 d-flex justify-content-between align-items-center rounded-2"
                  style={{ backgroundColor: "#00000022", cursor: "pointer" }}
                  onClick={() => toggleCategoryOpen(item.title)}
                >
                  <div>{item.title}</div>
                  {item.open ? (
                    <ChevronUp size={20} className="fw-bold" />
                  ) : (
                    <ChevronDown size={20} className="fw-bold" />
                  )}
                </div>
                {(item.open || searchQuery !== "") &&
                  (item.list?.length &&
                  item.list.filter((listItem) =>
                    listItem["Attachment"].title
                      .toLowerCase()
                      .includes(searchQuery?.toLowerCase())
                  )?.length > 20 ? (
                    <PaginatedTable
                      data={item.list.filter((listItem) =>
                        listItem["Attachment"].title
                          .toLowerCase()
                          .includes(searchQuery?.toLowerCase())
                      )}
                      rowsPerPage={20}
                    />
                  ) : (
                    <Table>
                      <tbody>
                        {item.list?.length ? (
                          item.list
                            .filter((listItem) =>
                              listItem["Attachment"].title
                                .toLowerCase()
                                .includes(searchQuery?.toLowerCase())
                            )
                            .map((listItem, index) => (
                              <tr key={index} className="m-5">
                                <td
                                  style={
                                    isLargeDevice ? { minWidth: "28rem" } : null
                                  }
                                >
                                  <div className="d-flex">
                                    <ReportsAndDocumentsIcon />
                                    <div>
                                      <div
                                        role="button"
                                        className="linkClick cursor-pointer text-decoration-underline"
                                        onClick={() => handleClick(listItem)}
                                      >
                                        {listItem["Attachment"].title}
                                      </div>
                                    </div>
                                  </div>
                                </td>
                                <td className="text-black-50">
                                  {moment(new Date(listItem["date"])).format(
                                    "MMM DD, yyyy"
                                  )}
                                </td>
                                <td className="text-black-50">PDF</td>
                                <td>
                                  <Button
                                    className="down-btn"
                                    onClick={() => handleClick(listItem)}
                                  >
                                    <DownloadIcon /> Download
                                  </Button>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td>No Data</td>
                          </tr>
                        )}
                      </tbody>
                    </Table>
                  ))}
              </div>
            ))
          ) : (
            <div>
              <SpinnerBlock height="50vh" />
            </div>
          )}
        </div>
      </section>
      <style>
        {`
            .input-icon{
                background-color: rgba(0, 0, 0, 0.133);
                border: none;
            }
            .search-input{
                border: none;
                background-color: rgba(0, 0, 0, 0.133);
                padding:8px;
                border-radius:5px;
                width:20rem !important;
                margin-left: 0px !important;
            }
            .down-btn{
                background: #F0F6FF;
                color: #438FFF;
                border: none;
            }
            .up-btn{
              background: #FFF;
              color: #438FFF;
              border-color:#438FFF;
            }
          `}
      </style>
    </div>
  );
};

export default BorrowerViewStatement;
